import { AxiosResponse } from 'axios';
import { apiClient } from '../instance';
import { Invite } from '../../types/interfaces';

export const invitesApi = {
  getInvites: ({id}: {id: number}): Promise<AxiosResponse<Invite[]>> => apiClient.get(`invites?status=unused&owner=${id}`),

  createInvite: (inviteData: Partial<Invite>): Promise<AxiosResponse<Invite>> =>
    apiClient.post<Invite>('invites/', inviteData),

  getInvite: (inviteId: string): Promise<AxiosResponse<Invite>> =>
    apiClient.get<Invite>(`invites/${inviteId}/`),

  // Публичная ручка для страницы /registration/<uuid>: отдаёт
  // узкое представление инвайта без auth (см. бэк
  // `InviteViewSet.registration` и `PublicInviteSerializer`).
  // Использовать ТОЛЬКО для незалогиненного сценария регистрации.
  // Для всех остальных мест (админка, менеджер видит чужие инвайты,
  // /roles/invites/ и т.п.) — оставляем getInvite/IsAuthenticated.
  getInviteForRegistration: (
    inviteId: string
  ): Promise<AxiosResponse<Invite>> =>
    apiClient.get<Invite>(`invites/${inviteId}/registration/`),

  deleteInvite: (inviteId: string): Promise<AxiosResponse<void>> =>
    apiClient.delete(`invites/${inviteId}/`),
};
